import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoBranchsGetReq } from "./abst/DtoBranchsGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoBranchsGetReqImple extends DtoBranchsGetReq {
  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
